export const portalMessages = {
   zh: {
    common: {
      login: '登录',
      register: '免费注册',
      email: '邮箱地址',
      password: '密码',
      phone: '手机号码',
      phoneNumber: '手机号码',
      phoneOrEmail: '手机号码或邮箱地址',
      accountIdentifier: '用户名、手机号或邮箱',
      verificationCode: '验证码',
      sendCode: '获取验证码',
      resendCode: '重新发送',
      countdown: '秒后重新发送',
      forgotPassword: '忘记密码？',
      welcome: '请输入您的账号信息进行登录',
      joinUs: '欢迎加入我们',
      hello: '初次见面',
      helloAgain: '欢迎回来',
      username: '用户名',
      contact: '联系方式',
      confirmPassword: '确认密码',
      inviteCode: '邀请码',
      getInviteCode: '获取邀请码',
      adminWechatInviteTip: '添加管理员微信获取邀请码',
      adminWechatQrAlt: '管理员微信二维码',
      registerSuccess: '注册成功！',
      registerFailed: '注册失败，请重试',
      back: '返回',
      noAccount: '还没有账号?',
      hasAccount: '已有账号?'
    },
    platform: {
      title: '大象魔法AIGC',
      subtitle: '魔法在手，驰骋全球',
      readMore: '了解更多'
    },
    validation: {
      required: '此字段为必填项',
      invalidPhone: '请输入有效的手机号码',
      invalidEmail: '请输入有效的邮箱地址',
      invalidPassword: '密码至少需要6个字符',
      usernameRequired: '请输入用户名',
      usernameLength: '用户名长度必须在2-20个字符之间',
      contactRequired: '请输入联系方式',
      contactInvalid: '请输入有效的联系方式',
      emailRequired: '请输入邮箱地址',
      emailInvalid: '请输入有效的邮箱地址',
      passwordRequired: '请输入密码',
      passwordLength: '密码至少需要6个字符',
      confirmPasswordRequired: '请确认密码',
      passwordMismatch: '两次输入的密码不一致',
      phoneRequired: '请输入手机号码',
      phoneInvalid: '请输入有效的手机号码',
      verificationCodeRequired: '请输入验证码',
      verificationCodeInvalid: '验证码格式不正确',
      inviteCodeRequired: '请输入邀请码',
      accountRequired: '请输入用户名、手机号或邮箱',
      accountInvalid: '请输入有效的用户名、手机号或邮箱'
    },
    paymentUnavailable: {
      title: '支付暂不可用',
      message: '需要充值试用请添加客服微信'
    },
    home: {
      user: {
        validity: '有效期',
        progress: '进度(节)',
        tutorHelp: '导师求助',
        myAccount: '我的账号',
        inviteGift: '邀请有礼'
      },
      menu: {
        buy: "购买"
      },
      content: {
        heading: '标题',
        subheading: '副标题',
        body: '这是文章的正文内容。我们添加了一些示例文本来展示页面效果：',
        lorem: '这是一段示例文本，用于展示页面的排版效果。这里可以放置实际的课程内容，包括课程介绍、学习要点、实践案例等。通过合理的排版和布局，让内容更加清晰易读。',
        nothing: '暂无内容',
        prevCourse: '← 上一个课程',
        nextCourse: '下一个课程 →'
      },
      buy: {
      },
      edit: {
        startEdit: '编辑',
        finishEdit: '结束编辑'
      },
    },
    profile: {
      menu: {
        info: '个人信息',
        courses: '我的课程',
        orders: '我的订单',
        settings: '账号设置',
        logout: '退出登录'
      },
      info: {
        username: '用户名',
        mobile: '联系方式',
        email: '邮箱',
        save: '保存修改'
      },
      courses: {
        title: '课程名称',
        progress: '学习进度',
        action: '操作',
        continue: '继续学习'
      },
      orders: {
        orderNo: '订单号',
        amount: '金额',
        status: '状态',
        createTime: '创建时间',
        action: '操作',
        detail: '查看详情',
        statusText: {
          pending: '待支付',
          paid: '已支付',
          cancelled: '已取消',
          refunded: '已退款'
        }
      },
      settings: {
        oldPassword: '原密码',
        newPassword: '新密码',
        confirmPassword: '确认密码',
        save: '修改密码'
      },
      deleteConfirm: '确定要删除该课程吗？',
      warning: '警告',
      confirm: '确定',
      cancel: '取消',
      deleteSuccess: '删除成功',
      deleteSectionConfirm: '确定要删除该章节吗？',
      deleteSectionSuccess: '章节删除成功'
    },
    legal: {
      termsOfService: '服务条款',
      privacyPolicy: '隐私政策',
      lastUpdated: '最后更新时间',
      terms: {
        section1: {
          title: '1. 服务说明',
          content: '大象魔法AIGC（以下简称"本平台"）是一个提供AI工具和服务的在线平台。通过使用本平台，您同意遵守以下服务条款。本平台致力于为用户提供高质量的AI工具和服务，帮助用户提高工作效率。'
        },
        section2: {
          title: '2. 用户责任',
          content: '用户在使用本平台服务时，应当遵守相关法律法规，不得利用本平台从事违法活动。用户应当妥善保管自己的账号信息，不得将账号转让或出借给他人使用。用户应当对自己在本平台上的行为承担相应的法律责任。'
        },
        section3: {
          title: '3. 知识产权',
          content: '本平台的所有内容，包括但不限于文字、图片、音频、视频、软件、程序、版面设计等，均受知识产权法保护。未经本平台书面许可，任何人不得复制、传播、展示、镜像、上载、下载本平台内容。'
        },
        section4: {
          title: '4. 服务变更',
          content: '本平台保留随时修改或中断服务的权利，且无需对用户或第三方负责。本平台有权在必要时修改服务条款，服务条款一旦发生变动，将会在重要页面上提示修改内容。'
        },
        section5: {
          title: '5. 免责声明',
          content: '本平台不对因网络服务的中断或其他不可抗力而给用户造成的损失承担责任。本平台不保证服务不会中断，也不保证服务的及时性、安全性、准确性。'
        },
        section6: {
          title: '6. 争议解决',
          content: '本服务条款的订立、执行和解释及争议的解决均应适用中华人民共和国法律。如双方就本服务条款内容或其执行发生任何争议，双方应尽量友好协商解决。'
        }
      },
      privacy: {
        section1: {
          title: '1. 信息收集',
          content: '我们收集您提供的信息，包括但不限于：注册信息（如姓名、邮箱、手机号）、使用记录、设备信息等。我们承诺仅收集提供服务所必需的信息，并采取适当的安全措施保护您的个人信息。'
        },
        section2: {
          title: '2. 信息使用',
          content: '我们使用收集的信息用于：提供和改进服务、个性化用户体验、发送服务通知、处理用户反馈等。我们不会将您的个人信息用于其他商业目的，除非获得您的明确同意。'
        },
        section3: {
          title: '3. 信息共享',
          content: '我们不会向第三方出售、出租或以其他方式披露您的个人信息，除非：获得您的明确同意、法律法规要求、保护我们的合法权益、与授权合作伙伴共享必要信息以提供服务。'
        },
        section4: {
          title: '4. 信息安全',
          content: '我们采用行业标准的安全技术和程序来保护您的个人信息，包括数据加密、访问控制、安全审计等措施。我们定期审查和更新安全措施，以应对新的安全威胁。'
        },
        section5: {
          title: '5. 信息保留',
          content: '我们仅在提供服务所必需的期间内保留您的个人信息。当您删除账户或我们不再需要您的信息时，我们会安全地删除或匿名化处理这些信息。'
        },
        section6: {
          title: '6. 您的权利',
          content: '您有权访问、更正、删除您的个人信息，有权撤回同意、投诉举报等。您可以通过账户设置或联系我们的客服来行使这些权利。我们会在合理时间内响应您的请求。'
        },
        section7: {
          title: '7. 政策更新',
          content: '我们可能会不时更新本隐私政策。当政策发生重大变更时，我们会通过电子邮件或网站公告的方式通知您。建议您定期查看本政策，了解我们如何保护您的信息。'
        }
      }
    }
  },
  en: {
    common: {
      login: 'Login',
      register: 'Register',
      email: 'Email Address',
      password: 'Password',
      phone: 'Phone Number',
      phoneNumber: 'Phone Number',
      phoneOrEmail: 'Phone Number or Email Address',
      accountIdentifier: 'Username, Phone Number, or Email',
      verificationCode: 'Verification Code',
      sendCode: 'Send Code',
      resendCode: 'Resend',
      countdown: 's to resend',
      forgotPassword: 'Forgot Password?',
      welcome: 'Welcome Back',
      joinUs: 'Join Us',
      hello: 'Hello',
      helloAgain: 'Hello Again',
      username: 'Username',
      contact: 'Contact',
      confirmPassword: 'Confirm Password',
      inviteCode: 'Invite Code',
      getInviteCode: 'Get Invite Code',
      adminWechatInviteTip: 'Add the administrator on WeChat to get an invite code',
      adminWechatQrAlt: 'Administrator WeChat QR code',
      registerSuccess: 'Registration successful!',
      registerFailed: 'Registration failed, please try again',
      back: 'Back',
      noAccount: "Don't have an account?",
      hasAccount: 'Already have an account?'
    },
    platform: {
      title: 'Kesai AI Toolbox',
      subtitle: 'Master tools, conquer all',
      readMore: 'Learn More'
    },
    validation: {
      required: 'This field is required',
      invalidPhone: 'Please enter a valid phone number',
      invalidEmail: 'Please enter a valid email address',
      invalidPassword: 'Password must be at least 6 characters',
      usernameRequired: 'Please enter username',
      usernameLength: 'Username must be between 2-20 characters',
      contactRequired: 'Please enter contact information',
      contactInvalid: 'Please enter valid contact information',
      emailRequired: 'Please enter email address',
      emailInvalid: 'Please enter a valid email address',
      passwordRequired: 'Please enter password',
      passwordLength: 'Password must be at least 6 characters',
      confirmPasswordRequired: 'Please confirm password',
      passwordMismatch: 'Passwords do not match',
      phoneRequired: 'Please enter phone number',
      phoneInvalid: 'Please enter a valid phone number',
      verificationCodeRequired: 'Please enter verification code',
      verificationCodeInvalid: 'Invalid verification code format',
      inviteCodeRequired: 'Please enter invite code',
      accountRequired: 'Please enter username, phone number, or email',
      accountInvalid: 'Please enter a valid username, phone number, or email'
    },
    paymentUnavailable: {
      title: 'Payment Unavailable',
      message: 'Payment is not configured yet. Add customer service on WeChat for a trial recharge.'
    },
    legal: {
      termsOfService: 'Terms of Service',
      privacyPolicy: 'Privacy Policy'
    }
  },
  vi: {
    common: {
      login: 'Đăng nhập',
      register: 'Đăng ký',
      email: 'Địa chỉ Email',
      password: 'Mật khẩu',
      phone: 'Số điện thoại',
      phoneNumber: 'Số điện thoại',
      phoneOrEmail: 'Số điện thoại hoặc địa chỉ Email',
      accountIdentifier: 'Tên người dùng, số điện thoại hoặc Email',
      verificationCode: 'Mã xác thực',
      sendCode: 'Gửi mã',
      resendCode: 'Gửi lại',
      countdown: 's để gửi lại',
      forgotPassword: 'Quên mật khẩu?',
      welcome: 'Chào mừng trở lại',
      joinUs: 'Tham gia cùng chúng tôi',
      hello: 'Xin chào',
      helloAgain: 'Xin chào lại',
      username: 'Tên người dùng',
      contact: 'Liên hệ',
      confirmPassword: 'Xác nhận mật khẩu',
      inviteCode: 'Mã mời',
      getInviteCode: 'Nhận mã mời',
      adminWechatInviteTip: 'Thêm quản trị viên trên WeChat để nhận mã mời',
      adminWechatQrAlt: 'Mã QR WeChat của quản trị viên',
      registerSuccess: 'Đăng ký thành công!',
      registerFailed: 'Đăng ký thất bại, vui lòng thử lại',
      back: 'Quay lại',
      noAccount: 'Chưa có tài khoản?',
      hasAccount: 'Đã có tài khoản?'
    },
    platform: {
      title: 'Kesai AI Toolbox',
      subtitle: 'Làm chủ công cụ, chinh phục tất cả',
      readMore: 'Tìm hiểu thêm'
    },
    validation: {
      required: 'Trường này là bắt buộc',
      invalidPhone: 'Vui lòng nhập số điện thoại hợp lệ',
      invalidEmail: 'Vui lòng nhập địa chỉ email hợp lệ',
      invalidPassword: 'Mật khẩu phải có ít nhất 6 ký tự',
      usernameRequired: 'Vui lòng nhập tên người dùng',
      usernameLength: 'Tên người dùng phải có từ 2-20 ký tự',
      contactRequired: 'Vui lòng nhập thông tin liên hệ',
      contactInvalid: 'Vui lòng nhập thông tin liên hệ hợp lệ',
      emailRequired: 'Vui lòng nhập địa chỉ email',
      emailInvalid: 'Vui lòng nhập địa chỉ email hợp lệ',
      passwordRequired: 'Vui lòng nhập mật khẩu',
      passwordLength: 'Mật khẩu phải có ít nhất 6 ký tự',
      confirmPasswordRequired: 'Vui lòng xác nhận mật khẩu',
      passwordMismatch: 'Mật khẩu không khớp',
      phoneRequired: 'Vui lòng nhập số điện thoại',
      phoneInvalid: 'Vui lòng nhập số điện thoại hợp lệ',
      verificationCodeRequired: 'Vui lòng nhập mã xác thực',
      verificationCodeInvalid: 'Định dạng mã xác thực không đúng',
      inviteCodeRequired: 'Vui lòng nhập mã mời',
      accountRequired: 'Vui lòng nhập tên người dùng, số điện thoại hoặc email',
      accountInvalid: 'Vui lòng nhập tên người dùng, số điện thoại hoặc email hợp lệ'
    },
    paymentUnavailable: {
      title: 'Thanh toán chưa khả dụng',
      message: 'Hệ thống chưa cấu hình thanh toán. Hãy thêm dịch vụ khách hàng trên WeChat để nạp thử.'
    },
    legal: {
      termsOfService: 'Điều khoản dịch vụ',
      privacyPolicy: 'Chính sách bảo mật'
    }
  }
}
